import React, { useState, useEffect } from 'react';
import { getUserStats, getUserSubscriptionFeatures } from '../components/apiClient';
import { useJWTAuth } from '../components/JWTAuthContext';
import {
  PointSummaryWidget,
  PointTransactionHistory,
  PointsLeaderboard,
  AITutorInterface,
  QuickActions,
  QuickStats,
  QuizHistorySection,
  PointSystemGuide,
  PointsMotivationBanner
} from '../components/dashboard';

const Dashboard: React.FC = () => {
  const { user } = useJWTAuth();
  const [userStats, setUserStats] = useState<any>({
    tests_completed: 0,
    overall_progress: 0,
    study_time_hours: 0,
    current_rank: 0
  });
  const [subscriptionData, setSubscriptionData] = useState<any>(null);

  useEffect(() => {
    console.log("User:", user);
    const fetchData = async () => {
      if (user && user.id) {
        try {
          const [statsResponse, subscriptionResponse] = await Promise.all([
            getUserStats(user.id),
            getUserSubscriptionFeatures()
          ]);
          
          if (statsResponse && statsResponse.result) {
            setUserStats(statsResponse.result);
          }
          console.log("Subscription Response:", subscriptionResponse);
          if (subscriptionResponse && subscriptionResponse.result) {
            setSubscriptionData(subscriptionResponse.result);
          }
        } catch (error) {
          console.error('Failed to fetch user data:', error);
        }
      }
    };

    fetchData();
  }, [user]);

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9ff', paddingTop: '0px' }}>
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            {/* Welcome Header */}
            {/* <WelcomeHeader user={user} /> */}

            {/* Points Motivation Banner */}
            <PointsMotivationBanner />

            {/* Quick Stats */}
            <QuickStats userStats={userStats} subscriptionData={subscriptionData} />

            {/* Quick Actions */}
            <QuickActions />

            {/* Point System Guide */}
            <PointSystemGuide />

            {/* Point System Dashboard */}
            <div className="row g-4 mt-2">
              <div className="col-md-6">
                <PointSummaryWidget />
              </div>
              <div className="col-md-6">
                <AITutorInterface />
              </div>
            </div>

            {user && (user.id === "258" || user.id === "257") && <div className="row g-4 mt-4">
              <div className="col-md-8">
                <PointTransactionHistory />
              </div>
              <div className="col-md-4">
                <PointsLeaderboard />
              </div>
            </div>}

            {/* Quiz History Section */}
            {/* <QuizHistorySection /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
